<template>
  <div class="awardList">
    <van-list
      v-model="isUpLoading"
      :finished="finished"
      :error.sync="error"
      error-text="请求失败，点击重新加载"
      @load="onReachBottom"
      class="leaderboard-list"
    >
      <div
        v-for="(list,listIndex) in rankList"
        :key="listIndex"
        class="awardList-list"
      >
        <div class="awardList-time">
          <i class="iconfont icon-yushou"></i>
          <span>{{list.startTime}}至{{list.endTime}}</span>
        </div>
        <div
          class="awardList-item"
          v-for="(item,index) in list.rankList"
          :key="index"
        >
          <div class="title">
            <b>第{{item.rank}}名</b>
            <span class="van-ellipsis" style="flex: 1">{{item.csName}}</span>
            <strong v-if="item.selfFlag == 1">我</strong>
          </div>
          <div class="content">
            <span class="van-ellipsis">奖品: {{item.awardType == 0 ? `优惠券${item.walletMoney}元` : item.awardType == 1 ? `${item.walletMoney}元` : item.productName}}</span>
            <span
              class="amount"
              v-if="item.awardType == 2"
            >* {{item.amount}}</span>
          </div>
        </div>
      </div>
      <template v-if="!rankList.length && !isUpLoading && !error">
        <div class="notHave">
          <i class="iconfont icon-zhixiang1"></i>
          <p>本周排行榜更新中哦～</p>
        </div>
      </template>
    </van-list>
  </div>
</template>

<script>
import { inviteRecordList } from "@/api/join";
export default {
  data() {
    return {
      active: 0,
      rankList: [],
      isUpLoading: false,
      finished: false,
      pageIndex: 1,
      error: false
    }
  },
  methods: {
    // 上拉加载
    onReachBottom() {
      this.getInviteRecordList();
    },
    getInviteRecordList() {
      inviteRecordList({
        page: {
          way: "1", // 0:不分页 后台最多返回999条数据 1:分页
          index: this.pageIndex, // 请求页数，index = 1 表示第一页
          size: "10", //数量
        },
        rankType: "2", //286 0是邀请，1 首单，后台默认接收参数0
      })
        .then((res) => {
          if (res.appStatus.errorCode == 0) {
            const list = res.content.list;
            if (list.length < 10) {
              // 最后一页不足10条的情况
              this.finished = true;
            }
            // 处理数据
            if (this.pageIndex === 1) {
              this.rankList = list;
            } else {
              this.rankList = this.rankList.concat(list);
            }
            this.pageIndex++;
          } else {
            this.error = true;
          }
          this.isUpLoading = false;
        })
        .catch((res) => {
          this.error = true;
          this.isUpLoading = false;
        });
    },
  },
  beforeCreate() {
    document.body.style.backgroundColor = "#FEEADD";
  }
}
</script>

<style lang="scss" scoped>
.awardList-list {
  padding: 10px 12px 0;
  .awardList-time {
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    color: #333333;
    i {
      margin-right: 10px;
      font-size: 13px;
      color: #e59a6c;
    }
    span {
      font-weight: bold;
    }
  }
  .awardList-item {
    border: 1px solid #efd5d6;
    border-radius: 7px;
    .title {
      display: flex;
      align-items: center;
      height: 40px;
      line-height: 40px;
      padding: 0 10px;
      font-size: 14px;
      color: #333333;
      background-color: #fff8f1;
      b {
        margin-right: 10px;
        font-weight: 800;
        color: #fe0403;
      }
      strong {
        width: 16px;
        height: 16px;
        line-height: 16px;
        font-size: 11px;
        color: #ffffff;
        background-color: #e59a6c;
        text-align: center;
        border-radius: 50%;
      }
    }
    .content {
      height: 40px;
      padding: 0 10px;
      display: flex;
      align-items: center;
      font-size: 15px;
      color: #333333;
      background-color: #ffffff;
      .amount {
        margin-left: 20px;
        flex: 0 0 auto;
      }
    }
  }
}
.notHave {
  height: calc(100vh - 88px);
  text-align: center;
  i {
    display: block;
    padding-top: 188px;
    font-size: 60px;
    color: #ffb98e;
  }
  p {
    margin-top: 2px;
    font-size: 13px;
    color: #999999;
  }
}
</style>
<style scoped>
.awardList >>> .van-tab {
  font-weight: bold;
}
.awardList >>> .van-tab--active {
  font-size: 16px;
}
.awardList >>> .van-tabs__line {
  background-color: #ff7b2b;
}
</style>